import React, { useState } from 'react'
import {
    Typography,
    Paper, Tabs, Tab, Box,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types'

import Message from './Components/Message/Message'
import MessageMultiple from './Components/MessageMultiple/MessageMultiple'


import MailOutlineIcon from '@material-ui/icons/MailOutline';
import TelegramIcon from '@material-ui/icons/Telegram';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
// import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import NoMeetingRoomIcon from '@material-ui/icons/NoMeetingRoom';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    appBar: {
        borderRadius: '4px 4px 0px 0px'
    },
    tabs:{
        borderBottom: '1px solid lightgrey'
    },
    tab:{
        width: '50%'
    },
    title:{
        display: 'flex',
        alignItems: 'center',
        padding: '18px 0px 4px 20px',
        '& h5':{
            marginLeft: 5
        }
    },
    panelDiv:{
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
    }
}));


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`wrapped-tabpanel-${index}`}
            aria-labelledby={`wrapped-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


export default function TabsComp() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>
            <Paper className={classes.panelDiv}>
                <div className={classes.title}>
                    <NotificationsNoneIcon />
                    <Typography  variant="h5" >
                        Notifications
                    </Typography>
                </div>
               
                <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" className={classes.tabs}>
                    <Tab label="App Notifications" {...a11yProps(0)}  className={classes.tab}/>
                    <Tab label="Messages" {...a11yProps(1)}  className={classes.tab}/>

                </Tabs>
             
                <TabPanel value={value} index={0}>  
                 
                    <Message
                        title='ORDER'
                        msg='Alexa has placed an order for 3 items of $10000'
                        imageSrc='/images/avatars/image91.jpg'
                    />
                    <Message
                        title='TICKET'
                        msg='Cristian raised support ticket'
                        imageSrc='/images/avatars/image9.jpg'
                    />
                    <Message
                        title='ENQUIRY'
                        msg='Jennifer needs information about product A150'
                        imageSrc='/images/avatars/image8.jpg'
                    />
                     <Message
                        title='ORDER'
                        msg='Caroline placed an order for 2 items of $5000'
                        imageSrc='/images/avatars/image95.jpg'
                    />
                </TabPanel>
                <TabPanel value={value} index={1}>

                    <MessageMultiple
                        
                        msg='Build Released'
                        imageSrc='/images/avatars/image4.jpg'
                    >
                       <div style={{display: 'flex', alignItems: 'center'}}>
                            <CheckCircleOutlineIcon />
                            <Typography variant="h6">
                                Task Completed
                            </Typography>
                            <Typography variant="body1">
                               &nbsp; 10: 20 AM
                            </Typography>
                       </div>
                        
                    </MessageMultiple>
                    <MessageMultiple
                       
                        msg='About Project Praposal'
                        imageSrc='/images/avatars/image94.jpg'
                    > 
                         <div style={{display: 'flex', alignItems: 'center'}}>
                            <TelegramIcon color="primary"/>
                            <Typography variant="h6" color="primary">
                                Client Message
                            </Typography>
                            <Typography variant="body1">
                               &nbsp; 9: 00 AM
                            </Typography>
                       </div>
                    </MessageMultiple>
                    <MessageMultiple
                        
                        msg='Attention needed for support'
                        imageSrc='/images/avatars/image93.jpg'
                    >
                      <div style={{display: 'flex', alignItems: 'center'}}>
                            <MailOutlineIcon color="secondary" />
                            <Typography variant="h6" color="secondary">
                                Mail Received
                            </Typography>
                            <Typography variant="body1">
                               &nbsp; Yesterday
                            </Typography>
                       </div>
                    </MessageMultiple>
                    <MessageMultiple
                       
                        msg='Project Discussion'
                        imageSrc='/images/avatars/image91.jpg'
                    > 
                         <div style={{display: 'flex', alignItems: 'center'}}>
                            <NoMeetingRoomIcon color="primary"/>
                            <Typography variant="h6" color="primary">
                                Meeting Postponed
                            </Typography>
                            <Typography variant="body1">
                                &nbsp; Yesterday
                            </Typography>
                       </div>
                    </MessageMultiple>


                </TabPanel>
            </Paper>
        </>
    )
}

